import { useMyAgentQuery, useSetMyChatStatusMutation } from 'hooks/useAgents';

export function AgentStatusToggle() {
  const { data: me } = useMyAgentQuery();
  const setStatus = useSetMyChatStatusMutation();

  if (!me) return null;

  const isOnline = me.chatStatus === 'online';
  return (
    <button
      type="button"
      onClick={() => setStatus.mutate(isOnline ? 'away' : 'online')}
      disabled={setStatus.isPending}
      title="Växla din status (Online / Borta)"
      className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:opacity-60"
    >
      <span className={`h-2 w-2 rounded-full ${isOnline ? 'bg-green-500' : 'bg-amber-500'}`} />
      {isOnline ? 'Online' : 'Borta'}
    </button>
  );
}
